export const notificationKeys = {
  all: [{ scope: "notification" }] as const,
  list: (params: Record<string, unknown>) =>
    [...notificationKeys.all, { entity: "list", ...params }] as const,
  infinite: (params: Record<string, unknown>) =>
    [...notificationKeys.all, { entity: "infinite", ...params }] as const,
};
